import { useState } from "react";
import { ChevronDown, FileWarning } from "lucide-react";

export const EmptyRowsPanel = ({ info }) => {
  const [open, setOpen] = useState(false);
  if (!info) return null;
  const total = info.rows.reduce((a, r) => a + r.n, 0);
  return (
    <div data-testid="empty-rows-panel" className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-200">
      <button type="button" data-testid="empty-rows-toggle" onClick={() => setOpen(!open)} className="flex w-full items-center gap-2 text-left font-semibold">
        <FileWarning className="h-4 w-4" />{info.title}: {total} baris di {info.rows.length} unit
        <ChevronDown className={`ml-auto h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <p className="mt-0.5 text-xs opacity-80">{info.note} Baris ini tidak dihitung dalam rata-rata rasio.</p>
      {open && (
        <table className="mt-3 w-full text-xs">
          <thead><tr className="text-left uppercase tracking-wider opacity-70"><th className="py-1">Unit</th><th>Bulan</th><th className="text-right">Baris</th></tr></thead>
          <tbody>
            {info.rows.map((r) => (
              <tr key={r.unit} data-testid={`empty-row-${r.unit}`} className="border-t border-amber-200 dark:border-amber-900">
                <td className="py-1.5 font-medium">{r.unit}</td><td>{r.bulan}</td><td className="text-right font-num">{r.n}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
